<template>
  <DoubleCard>
    <div
      v-if="weatherInfoLoader"
      class="loader-container"
    >
      <v-progress-circular
        indeterminate
        color="blue"
        width="2"
        size="38"
      />
    </div>

    <div
      v-else
      style="height:100%"
    >
      <div
        v-if="weatherData.length"
        class="weatherContainer"
      >
        <div
          v-for="(weather,i) in weatherData"
          :key="i"
          style="display:contents"
        >
          <div
            class="text-md-center text-no-wrap"
            style="line-height:1"
          >
            <p
              class="pt-2"
              style="font-weight:bold"
            >
              {{ dates[i] }}
            </p>
            <v-progress-circular
              v-if="!isLoaded[i]"
              class="mt-3 mb-4"
              indeterminate
              color="blue"
              width="1"
              size="22"
            />
            <img
              v-show="isLoaded[i]"
              class="imgClass"
              :src="weather.icons.normal"
              @load="$set(isLoaded, i, true)"
            >
            <p class="temp">
              <span class="temp-low">
                {{ Math.round(weather.temperatures.min) }}
              </span>
              ~
              <span class="temp-high">
                {{ Math.round(weather.temperatures.max) }}
              </span>
              °C
            </p>
          </div>
          <v-divider
            v-if="i<6"
            vertical
          />
        </div>
      </div>

      <div
        v-else
        class="info-text"
      >
        週間天気情報を取得できませんでした。
      </div>
    </div>
  </DoubleCard>
</template>

<script>
import { mapState } from 'vuex'
import { DoubleCard } from '@/components/ui'
import { getRelativeDates } from '@/utils/time'

export default {
  components: {
    DoubleCard
  },
  data () {
    return {
      isLoaded: new Array(7).fill(false)
    }
  },
  computed: {
    ...mapState('dashboard', ['weatherData', 'weatherInfoLoader']),

    dates () {
      return getRelativeDates(7, 0, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.imgClass {
  border-radius: 3px;
  margin-bottom: 10px;
  background-color: #add8e6b0;
}
.weatherContainer{
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.info-text{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 0.9rem;
  color: var(--metal-grey-d);
}
.loader-container{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding-top: 10px;
}
.temp {
  font-size: 0.9rem;
  font-weight: bold;

  &-high {
    color: red;
  }
  &-low {
    color: blue;
  }
}
</style>
